import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  fullName: '',
  phone: '',
  address: '',
  city: '',
  pincode: '',
  notes: '',
  latitude: null,
  longitude: null,
  mapLink: null
};

const deliveryAddressSlice = createSlice({
  name: 'deliveryAddress',
  initialState,
  reducers: {
    setDeliveryAddress: (state, action) => {
      return { ...state, ...action.payload };
    },
    updateLocationData: (state, action) => {
      state.latitude = action.payload.latitude;
      state.longitude = action.payload.longitude;
      state.mapLink = action.payload.mapLink;
    },
    clearDeliveryAddress: () => {
      return initialState;
    }
  }
});

export const { 
  setDeliveryAddress, 
  updateLocationData, 
  clearDeliveryAddress 
} = deliveryAddressSlice.actions;

export default deliveryAddressSlice.reducer;